export const formatNameAndSurname = (value: string): string => {
    if (!value) return "";

    return value
        .trim()
        .split(/\s+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
};

export const formatCarePlanName = (value: any) => {
    let words = value.split(" ");

    while (words.join(" ").length > 50) {
    words.pop();
    }

    return words.join(" ");
}